import React from "react";
import { useLanguage } from "../Language";
import { Button } from "@mui/material";
import { useReviewDialog } from "../../contexts/ReviewDialogContext";
import { ResourceDWR } from "@tlc/ls2pac/dto/ResourceDWR";

interface WriteYourReviewButtonProps {
  resource: ResourceDWR;
}
export const WriteYourReviewButton = ({
  resource,
}: WriteYourReviewButtonProps) => {
  const { translate } = useLanguage();
  const { showReviewDialog } = useReviewDialog();
  return (
    <Button variant="text" onClick={() => showReviewDialog(resource)}>
      {translate("writeAReview")}
    </Button>
  );
};
